import { NUMBER } from "../../../constants/app-constants";
import priceFormatter from "../../../utils/helpers/price-formatter";
import { DEFAULT_HOLD, HOLD_STATUES, HOLD_STATUS_TYPES } from "./constant";

export const daysUntilRelease = date => Math.ceil((new Date(date) - new Date()) / (NUMBER.THOUSAND * NUMBER.SIXTY * NUMBER.SIXTY * NUMBER.TWENTY_FOUR));

export const getVariantBadge = (paymentStatus) => {
    if (paymentStatus === HOLD_STATUS_TYPES.PENDING) return "warning";
    if ([HOLD_STATUS_TYPES.VERIFICATION_FAILED, HOLD_STATUS_TYPES.REVOKED].includes(paymentStatus)) return "error";
    return "success";
};

export const parseHoldsData = (holds, price, viewDetailHandler) => {
    const item = { ...DEFAULT_HOLD, title: `₹${price}` };
    const updatedHolds = holds.map(({ amount, bottomSheetEnabled, label, autoReleaseDate, additionalData, paymentStatus = "" }, index) => {
        if (!amount) return {};
        const variantBadge = getVariantBadge(paymentStatus);
        return {
            id: index,
            title: `₹ ${priceFormatter(amount)}`,
            subHeading: (additionalData &&  additionalData.heading) || label,
            description: additionalData && additionalData.descriptions &&  additionalData.descriptions[0],
            ...(bottomSheetEnabled && {
                buttonProps: {
                    label: "View Details",
                    variant: "brand",
                    preventDefaultBehaviour: true,
                    size: "small",
                    underLine: false,
                    href: "#",
                    onClick: () => viewDetailHandler(label),
                    asLink: true
                }
            }),
            ...((autoReleaseDate && paymentStatus) && {
                badgeProps: {
                    label: paymentStatus !== HOLD_STATUS_TYPES.PENDING ? HOLD_STATUES[paymentStatus] : `${daysUntilRelease(autoReleaseDate)} days`,
                    variant: variantBadge
                }
            }),
            additionalData
        };
    });

    return [item, ...updatedHolds];
};
